import React from "react";

import { CopyIcon } from "@packages/ds";
import { Command } from "cmdk";

import { useCommandMenuContext } from "../hooks";
import * as S from "../styles";

type ItemProps = {
  children: React.ReactNode;
  value: string;
  keywords?: string[];
  type?: "resource" | "action" | "copy";
  onSelect?: ((value: string) => void) | undefined;
  isVertical?: boolean;
} & React.ComponentProps<typeof Command.Item>;

export function Item({
  children,
  value,
  keywords,
  onSelect,
  type = "action",
  isVertical = false,
  ...props
}: ItemProps) {
  const { setIsCommandMenuOpen } = useCommandMenuContext();

  return (
    <Command.Item
      value={value}
      keywords={keywords}
      onSelect={() => {
        if (type !== "resource") setIsCommandMenuOpen(false);
        onSelect?.(value);
      }}
      className={isVertical ? "isVertical" : undefined}
      {...props}
    >
      {children}
      <S.Meta>{type === "copy" && <CopyIcon />}</S.Meta>
    </Command.Item>
  );
}
